<!-- My Dashboard Profile and License Sections -->
<section class="card mb-3" role="region" aria-labelledby="profile-heading">
  <div class="card-head d-flex justify-content-between align-items-center">
    <h5 id="profile-heading" class="profile">Profile Details</h5>
    <button class="inbox-btn" aria-label="Open Message Inbox" (click)="navigateToMessageInbox()" type="button">
      Message Inbox
    </button>
  </div>
  <hr class="full-width-line" role="presentation" aria-hidden="true" />
  <div class="card-body-profile">
    <div class="row" role="presentation">
      <div class="col-12 col-sm-6 col-md-3">
        <label class="label" id="name-label">Name on Record</label>
        <div class="value" aria-labelledby="name-label">{{ profile.name }}</div>
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <label class="label" id="email-label">Primary Email Address</label>
        <div class="value" aria-labelledby="email-label">{{ profile.email }}</div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2" *ngIf="isLicenseDataComplete">
        <label class="form-label mb-1" id="licenseNumber-label">License Number</label>
        <p class="font-weight mb-0" aria-labelledby="licenseNumber-label">{{ license.number }}</p>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2" *ngIf="isLicenseDataComplete">
        <label class="form-label mb-1" id="licenseStatus-label">License Status</label>
        <p class="font-weight mb-0" [ngClass]="license.status === 'Active' ? 'status-color' : 'status-color-inactive'" aria-labelledby="licenseStatus-label">
          {{ license.status }}
        </p>
      </div>
    </div>
  </div>
</section>

<app-accordian [title]="'My Applications'">
    <div
      class="header-row p-2 d-flex align-items-center justify-content-end mb-0"
      id="my_applications_div_headeractions">
      <div class="d-flex fix-gap-16">
        <div class="export-actions">
          <button
            mat-icon-button
            class="icon-btn"
            matTooltip="Export"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip"
            (click)="toggleDownloadDialog()"
            id="dashboard_export_btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                fill="currentColor" />
            </svg>
          </button>
          <div *ngIf="showDownloadDialog" class="download-dialog" id="dashboard_download_dialog">
            <div class="column-chooser-list">
              <div
                class="column-chooser-checkbox"
                (click)="downloadExcel(); closeDownloadDialog()"
                class="pointer"
                id="dashboard_download_excel">
                Download Excel
              </div>
              <div
                class="column-chooser-checkbox"
                (click)="downloadPDF(); closeDownloadDialog()"
                style="cursor: pointer"
                id="dashboard_download_pdf">
                Download PDF
              </div>
            </div>
          </div>
        </div>
        <div class="column-chooser-actions">
          <button
            mat-icon-button
            class="icon-btn"
            matTooltip="Column Chooser"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip"
            (click)="showColumnChooser = !showColumnChooser"
            id="dashboard_column_chooser_btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                fill="currentColor" />
            </svg>
          </button>
          <div *ngIf="showColumnChooser" class="column-chooser-dialog" id="dashboard_column_chooser_dialog">
            <div class="column-chooser-header">
              Column Chooser
              <button class="column-chooser-close" (click)="closeColumnChooser()" id="dashboard_column_chooser_close">
                &times;
              </button>
            </div>
            <div class="column-chooser-list">
              <label
                *ngFor="let col of allColumns"
                class="column-chooser-checkbox"
                [id]="'dashboard_column_' + col.dataField">
                <input
                  type="checkbox"
                  [(ngModel)]="visibleColumns[col.dataField]"
                  [disabled]="col.dataField === disableAppIdColumn" />
                {{ col.label }}
              </label>
            </div>
          </div>
        </div>
        <button
          mat-raised-button
          color="primary"
          class="start-btn"
          (click)="openApplicationTypeDialog()"
          id="dashboard_start_new_btn"
          type="button"
          aria-label="Start New Application">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            class="start-btn-icon"
            aria-hidden="true">
            <path
              d="M9.37516 10.6252V13.3335C9.37516 13.5106 9.43509 13.659 9.55495 13.7787C9.67482 13.8986 9.82329 13.9585 10.0004 13.9585C10.1776 13.9585 10.326 13.8986 10.4456 13.7787C10.5653 13.659 10.6252 13.5106 10.6252 13.3335V10.6252H13.3335C13.5106 10.6252 13.659 10.5652 13.7787 10.4454C13.8986 10.3255 13.9585 10.177 13.9585 9.99995C13.9585 9.82273 13.8986 9.67433 13.7787 9.55475C13.659 9.43502 13.5106 9.37516 13.3335 9.37516H10.6252V6.66683C10.6252 6.48975 10.5652 6.34134 10.4454 6.22162C10.3255 6.10176 10.177 6.04183 9.99995 6.04183C9.82273 6.04183 9.67433 6.10176 9.55475 6.22162C9.43502 6.34134 9.37516 6.48975 9.37516 6.66683V9.37516H6.66683C6.48975 9.37516 6.34134 9.43509 6.22162 9.55495C6.10176 9.67482 6.04183 9.82329 6.04183 10.0004C6.04183 10.1776 6.10176 10.326 6.22162 10.4456C6.34134 10.5653 6.48975 10.6252 6.66683 10.6252H9.37516ZM10.0016 17.9168C8.90662 17.9168 7.87738 17.7091 6.91391 17.2935C5.95044 16.8779 5.11238 16.314 4.39975 15.6016C3.68711 14.8893 3.12287 14.0516 2.70704 13.0885C2.29134 12.1254 2.0835 11.0965 2.0835 10.0016C2.0835 8.90662 2.29127 7.87738 2.70683 6.91391C3.12238 5.95044 3.68634 5.11238 4.3987 4.39975C5.11107 3.68711 5.94877 3.12287 6.91183 2.70704C7.87488 2.29134 8.90384 2.0835 9.9987 2.0835C11.0937 2.0835 12.1229 2.29127 13.0864 2.70683C14.0499 3.12238 14.8879 3.68634 15.6006 4.3987C16.3132 5.11107 16.8775 5.94877 17.2933 6.91183C17.709 7.87488 17.9168 8.90384 17.9168 9.9987C17.9168 11.0937 17.7091 12.1229 17.2935 13.0864C16.8779 14.0499 16.314 14.8879 15.6016 15.6006C14.8893 16.3132 14.0516 16.8775 13.0885 17.2933C12.1254 17.709 11.0965 17.9168 10.0016 17.9168ZM10.0002 16.6668C11.8613 16.6668 13.4377 16.021 14.7293 14.7293C16.021 13.4377 16.6668 11.8613 16.6668 10.0002C16.6668 8.13905 16.021 6.56266 14.7293 5.271C13.4377 3.97933 11.8613 3.3335 10.0002 3.3335C8.13905 3.3335 6.56266 3.97933 5.271 5.271C3.97933 6.56266 3.3335 8.13905 3.3335 10.0002C3.3335 11.8613 3.97933 13.4377 5.271 14.7293C6.56266 16.021 8.13905 16.6668 10.0002 16.6668Z"
              fill="white" />
          </svg>
          Start New Application
        </button>
        <div *ngIf="showDraftModal" class="draft-modal" id="dashboard_draft_modal">
          <div class="modal-content">
            <h2>Draft Application Found</h2>
            <p class="para-content">
              You already have a {{ getApplicationTypeDisplayValue(selectedDraftApplicationType) }} application in
              process.
            </p>
            <p class="para-content">
              Are you sure you want to delete the draft and start a new application, or would you like to continue with
              the existing draft?
            </p>
            <p class="para-content">Deleting this draft will permanently remove all entered information.</p>
            <hr />
            <div class="modal-actions">
              <button class="btn btn-secondary draft-btn" (click)="continueDraft()">Continue Draft</button>
              <button class="btn btn-draft-delete-submit" (click)="deleteAndStartNew()">Delete and Start New</button>
            </div>
          </div>
        </div>
        <div *ngIf="showDeficiencyModal" class="draft-modal" id="dashboard_deficiency_modal">
          <div class="modal-content">
            <h2>Application Deficiency</h2>
            <p class="para-content">
              Your application has deficiencies that need to be resolved. Would you like to open the application?
            </p>
            <hr />
            <div class="modal-actions">
              <button class="btn btn-secondary draft-btn" (click)="proceedWithDeficiencyApplication()">Proceed</button>
              <button class="btn btn-draft-delete-submit" (click)="cancelDeficiencyModal()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-grid-wrapper" id="dashboard_grid_wrapper" role="region" aria-label="My Applications Table">
      <app-data-grid
        [onApplicationClick]="onApplicationIdClick"
        [config]="dashboardDataGridConfig"
        [actionsTemplateRef]="dashboardActionTemplate"
        id="dashboard_grid_datagrid">
        <ng-template #dashboardActionTemplate let-row let-index="index">
          <div
            class="action-buttons-container d-flex gap_action"
            [id]="'dashboard_div_actions_' + row.application_id"
            role="group"
            [attr.aria-label]="'Actions for application ' + row.application_id">
            <div class="action-inline ml-4">
              <div class="action-flex">
                <!-- View button for all applications: now shows case communication PDF popup -->
                <!-- <button mat-icon-button class="action-icon-button" matTooltip="View" matTooltipPosition="above"
                matTooltipClass="custom-tooltip" (click)="viewCaseCommunicationPDF(row)"
                [id]="'dashboard_view_row_' + row.application_id" type="button"
                [attr.aria-label]="'View application ' + row.application_id">
                <img src="assets/images/neveda-images/eye.svg" alt="" width="24" height="24" aria-hidden="true" />
              </button> -->
                <button
                  *ngIf="row.hasCaseCommunication"
                  mat-icon-button
                  class="action-icon-button"
                  matTooltip="View Background Communication"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="viewCaseCommunicationPDF(row)"
                  [id]="'dashboard_view_row_' + row.application_id"
                  type="button"
                  [attr.aria-label]="'View application ' + row.application_id">
                  <img src="assets/images/download_background_check.svg" alt="" width="24" height="24" aria-hidden="true" />
                </button>

                <!-- Message / In-app messaging button with per-application unread badge -->
                <span class="message-icon-wrapper">
                  <button
                    mat-icon-button
                    class="action-icon-button"
                    matTooltip="Message-Inbox"
                    matTooltipPosition="above"
                    matTooltipClass="custom-tooltip"
                    (click)="openInAppMessaging(row); $event.stopPropagation()"
                    [id]="'dashboard_message_row_' + row.application_id"
                    type="button"
                    [attr.aria-label]="'Open message inbox for application ' + row.application_id">
                    <img src="assets/images/message.svg" alt="" width="24" height="24" aria-hidden="true" />
                  </button>
                  <span
                    *ngIf="getUnreadCountForApplication(row.id ?? row.application_id) > 0"
                    class="message-icon-badge"
                    [attr.aria-label]="getUnreadCountForApplication(row.id ?? row.application_id) + ' unread messages'">
                    {{
                      getUnreadCountForApplication(row.id ?? row.application_id) > 99
                        ? '99+'
                        : getUnreadCountForApplication(row.id ?? row.application_id)
                    }}
                  </span>
                </span>

                <!-- Download button for non-draft applications -->
                <button
                  *ngIf="
                    row.application_status && row.application_status.toLowerCase() !== 'in progress, not submitted' && !isLicenseExtension(row.application_type)
                  "
                  mat-icon-button
                  class="action-icon-button"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="downloadRowPDF(row)"
                  [id]="'dashboard_open_row_download_dialog_' + row.application_id"
                  type="button"
                  [attr.aria-label]="'Download application ' + row.application_id + ' as PDF'">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true">
                    <path
                      d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                      fill="currentColor" />
                  </svg>
                </button>
                <!-- Delete button only for draft applications -->
                <button
                  *ngIf="
                    row.application_status && row.application_status.toLowerCase() === 'in progress, not submitted'
                  "
                  mat-icon-button
                  class="action-icon-button"
                  matTooltip="Delete"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="openDeleteModal(row.application_id)"
                  [id]="'dashboard_delete_row_' + row.application_id"
                  type="button"
                  [attr.aria-label]="'Delete draft application ' + row.application_id">
                  <img
                    src="../../assets/images/neveda-images/delete-icon.svg"
                    alt=""
                    class="filter-icon"
                    aria-hidden="true" />
                </button>
                <!-- Deficiency Notes Download button only for draft applications -->
                <button
                  *ngIf="shouldShowDeficiencyDownload(row)"
                  mat-icon-button
                  class="action-icon-button"
                  matTooltip="External Deficiency Comments"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="downloadDeficiencyNotes(row)"
                  [id]="'dashboard_open_row_download_dialog_' + row.application_id"
                  type="button"
                  [attr.aria-label]="'Download deficiency notes for application ' + row.application_id">
                  <img src="assets/images/download_deficiency.svg" alt="" width="24" height="24" aria-hidden="true" />
                </button>
                <button
                  *ngIf="shouldShowDnqDownload(row)"
                  mat-icon-button
                  class="action-icon-button"
                  matTooltip="DNQ Communication - External"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="downloadDnqNotes(row)"
                  [id]="'dashboard_dnq_download_row_' + row.application_id"
                  type="button"
                  [attr.aria-label]="'Download DNQ Communication for application ' + row.application_id">
                  <img src="assets/images/download_dnq.svg" alt="" width="24" height="24" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </app-data-grid>
    </div>
  </app-accordian>

<!-- License Details Card -->
<app-accordian [title]="'License Details'" *ngIf="isLicenseDataComplete">
  <div class="mt-2">
    <div
      class="d-flex flex-column flex-md-row align-items-end align-items-md-center justify-content-between mb-3 gap-3">
      <div class="license-header-wrapper">
        <button
          id="my_dashboard_button_surrender_mobile"
          class="extend-license-btn extend-btn-mobile"
          type="button"
          aria-label="Surrender License"
          *ngIf="license.status == 'Active'" (click)="surrenderClick()">
          Surrender
        </button>
        <span
          [matTooltip]="extendButtonTooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
          class="extend-tooltip-wrapper"
          *ngIf="shouldShowExtendButton">
          <button
            id="my_dashboard_button_extendbtn"
            class="extend-license-btn extend-btn-mobile"
            (click)="onExtendLicense()"
            type="button"
            aria-label="Open extend license dialog"
            [disabled]="!isExtendButtonEnabled">
            Extend
          </button>
        </span>
      </div>

      <div
        class="d-flex flex-wrap gap-10 w-md-auto justify-content-end license-actions-wrapper license-action-row"
        role="group"
        aria-label="License Actions">
        <div
          class="tab-content border rounded my-applications-container-license left-space-remove"
          id="dashboard_div_view">
          <div class="header-row d-flex align-items-center justify-content-end mb-0">
            <div class="button-actions-container">
              <div class="button-wrapper">
                <button
                  type="button"
                  class="icon-btn"
                  [id]="'dashboard_button_view_' + license.application_id"
                  matTooltip="View"
                  matTooltipPosition="above"
                  aria-label="View License Details"
                  matTooltipClass="custom-tooltip"
                  (click)="viewApplication(license)">
                  <img src="assets/images/neveda-images/eye.svg" alt="" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="button-wrapper">
          <button
            type="button"
            class="icon-btn"
            [id]="'dashboard_button_message_' + license.application_id"
            matTooltip="Message-Inbox"
            matTooltipPosition="above"
            aria-label="Open message inbox"
            matTooltipClass="custom-tooltip"
            (click)="openInAppMessaging(license)">
            <img src="assets/images/message.svg" alt="" aria-hidden="true" />
          </button>
        </div> -->
        <div class="tab-content border rounded my-applications-container-license" id="dashboard_div_print">
          <div class="header-row d-flex align-items-center justify-content-end mb-0">
            <div class="button-actions-container">
              <div class="button-wrapper">
                <button
                  type="button"
                  class="icon-btn"
                  id="dashboard_button_print"
                  matTooltip="Print License"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="onPrint()"
                  aria-label="Print License">
                  <img src="assets/images/neveda-images/print.svg" alt="" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-content border rounded my-applications-container-license dwnld-btn" id="dashboard_div_download">
          <div class="header-row d-flex align-items-center justify-content-end mb-0">
            <div class="button-actions-container">
              <div class="button-wrapper">
                <button
                  class="icon-btn"
                  id="dashboard_button_export"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="downloadPDF()"
                  aria-label="Download License as PDF">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true">
                    <path
                      d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                      fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="license-action-row">
        <button
          class="extend-license-btn ml-1"
          type="button"
          title="Add"
          aria-label="Add"
          *ngIf="isEnableEndoresment" (click)="storeOldApplicationIdAndLoadEndorsement()">
          Add
        </button>
        <span
          [matTooltip]="extendButtonTooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
          class="extend-tooltip-wrapper"
          *ngIf="shouldShowExtendButton">
          <button
            id="my_dashboard_button_extendbtn"
            class="extend-license-btn extend-btn-desktop ml-1"
            (click)="onExtendLicense()"
            type="button"
            aria-label="Open extend license dialog"

            [disabled]="!isExtendButtonEnabled">
            Extend
          </button>
        </span>
        <span
          [matTooltip]="surrenderButtonTooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
          class="extend-tooltip-wrapper"
          *ngIf="license.status == 'Active'">
          <button
            id="my_dashboard_button_surrender_desktop"
            class="extend-license-btn extend-btn-desktop ml-1"
            type="button"
             aria-label="Surrender License"
            (click)="surrenderClick()">
            Surrender
          </button>
        </span>
        </div>
        <div class="license-action-row">
        <div
          class="tab-content rounded my-applications-container-license column-chooser-actions"
          id="dashboard_div_license_column_chooser">
          <app-grid-actions
            id="dashboard_license_grid_actions"
            [actions]="[
              {
                type: 'export',
                id: 'dashboard_button_=kind_export',
                title: 'Export',
                tooltip: 'Export',
                visible: true
              },
              {
                type: 'columnChooser',
                id: 'dashboard_button_license_column_chooser',
                title: 'Column Chooser',
                tooltip: 'Column Chooser',
                visible: true
              }
            ]"
            [showColumnChooser]="showLicenseKindColumnChooser"
            [allColumns]="licenseKindAllColumns"
            [visibleColumns]="licenseKindVisibleColumns"
            (columnChooserToggle)="toggleLicenseKindColumnChooser()"
            (columnToggle)="toggleLicenseKindColumn($event.key)"
            (columnChooserClose)="closeLicenseKindColumnChooser()"
            (exportClick)="onLicenseKindExport()">
          </app-grid-actions>
        </div>
        </div>
      </div>
    </div>

    <div class="row bottom-margin" aria-label="License Information">
      <div class="col-12">
        <app-data-grid
          [config]="licenseKindDataGridConfig"
          [statusDataField]="'licenseKindStatus'"
          [submittedStatusValues]="['Active', 'Eligible']"
          id="dashboard_license_datagrid">
        </app-data-grid>
      </div>
    </div>
<hr>
    <div
      class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3 gap-3">
      <div class="kind-header">Endorsements</div>
      <div class="endorsment-container">
      <div class="license-header-wrapper">
        <div class="tab-content rounded my-applications-container-license dwnld-btn" id="dashboard_div_download">
          <div class="header-row d-flex align-items-center justify-content-end mb-0">
            <div class="button-actions-container">
              <!-- <div class="button-wrapper">
                <button
                  class="icon-btn"
                  id="dashboard_button_export"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip"
                  (click)="downloadPDF()"
                  aria-label="Download License as PDF">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true">
                    <path
                      d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                      fill="currentColor" />
                  </svg>
                </button>
              </div> -->
              <div
          class="tab-content rounded my-applications-container-license column-chooser-actions"
          id="dashboard_div_license_column_chooser">
          <app-grid-actions
            id="dashboard_license_grid_actions"
            [actions]="[
              {
                type: 'export',
                id: 'dashboard_button_endorsement_export',
                title: 'Export',
                tooltip: 'Export',
                visible: true
              },
              {
                type: 'columnChooser',
                id: 'dashboard_button_license_column_chooser',
                title: 'Column Chooser',
                tooltip: 'Column Chooser',
                visible: true
              }
            ]"
            [showColumnChooser]="showLicenseColumnChooser"
            (exportClick)="onEndorsementExport()"
            [allColumns]="licenseAllColumns"
            [visibleColumns]="licenseVisibleColumns"
            (columnChooserToggle)="toggleLicenseColumnChooser()"
            (columnToggle)="toggleLicenseColumn($event.key)"
            (columnChooserClose)="closeLicenseColumnChooser()">
          </app-grid-actions>
        </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    <div class="row" aria-label="License Information">
      <div class="col-12">
        <app-data-grid
          [config]="licenseDataGridConfig"
          [statusDataField]="'endorsementStatus'"
          [submittedStatusValues]="['Active', 'Eligible']"
          id="dashboard_license_datagrid">
        </app-data-grid>
      </div>
    </div>
  </div>
</app-accordian>

<!-- License Dashboard Tables Section (merged inline) -->
<div class="outer-container" *ngIf="!isLoading">
  <!-- License Requirements Section -->
  <app-accordian [title]="licenseRequirementsSection.title" *ngIf="isLicenseDataComplete">
    <div
      class="header-row p-2 d-flex align-items-center justify-content-end mb-0"
      id="license_requirements_div_headeractions">
      <app-grid-actions
        id="license_requirements_grid_actions"
        [actions]="licenseRequirementsSection.gridActions"
        [statusDataField]="'application_status'"
        [submittedStatusValues]="['Active']"
        [showColumnChooser]="licenseRequirementsSection.showColumnChooser"
        [allColumns]="licenseRequirementsSection.allColumns"
        [visibleColumns]="licenseRequirementsSection.visibleColumns"
        (exportClick)="onLicenseRequirementsExport()"
        [onApplicationClick]="onApplicationIdClick"
        (columnChooserToggle)="onLicenseRequirementsColumnChooserToggle()"
        (columnToggle)="onLicenseRequirementsColumnToggle($event)"
        (columnChooserClose)="onLicenseRequirementsColumnChooserClose()">
      </app-grid-actions>
    </div>
    <app-data-grid
      #licenseRequirementsGrid
      [config]="licenseRequirementsSection.dataGridConfig"
      [statusColorOverrides]="provisionStatusColorOverrides"
      id="license_requirements_grid_datagrid">
    </app-data-grid>
  </app-accordian>

  <!-- My Applications Section -->


  <!-- My Documents Section -->
  <app-accordian [title]="myDocumentsSection.title">
    <div class="header-row p-2 d-flex align-items-center justify-content-end mb-0" id="my_documents_div_headeractions">
      <app-grid-actions
        id="my_documents_grid_actions"
        [actions]="myDocumentsSection.gridActions"
        [showColumnChooser]="myDocumentsSection.showColumnChooser"
        [allColumns]="myDocumentsSection.allColumns"
        [visibleColumns]="myDocumentsSection.visibleColumns"
        (exportClick)="onMyDocumentsExport()"
        (columnChooserToggle)="onMyDocumentsColumnChooserToggle()"
        (columnToggle)="onMyDocumentsColumnToggle($event)"
        (columnChooserClose)="onMyDocumentsColumnChooserClose()">
      </app-grid-actions>
    </div>
    <app-data-grid
      #myDocumentsGrid
      [statusDataField]="'document_status'"
      [documentStatusBadgeMode]="true"
      [submittedStatusValues]="['Uploaded', 'Verified', 'Validated']"
      [config]="myDocumentsSection.dataGridConfig"
      id="my_documents_grid_datagrid"
      (assign)="onAssign($event.record, $event.assign, $event.selectedStaffMemberId, $event.personsByRole)"
      [onApplicationClick]="onApplicationIdClick">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div
          class="action-buttons-container"
          [attr.data-row]="rowIndex"
          role="group"
          [attr.aria-label]="'Actions for document ' + data.document_id">
          <span class="action-span-wrapper view-wrapper">
            <button
              type="button"
              class="action-icon-button"
              [id]="'my_documents_button_view_' + data.document_id + '_' + rowIndex"
              #viewTooltip="matTooltip"
              matTooltip="View"
              matTooltipPosition="above"
              matTooltipTouchGestures="auto"
              [attr.aria-label]="'View document ' + data.document_id"
              (mouseenter)="hoverTooltipId = 'doc_view_' + data.document_id + '_' + rowIndex; viewTooltip.show()"
              (mouseleave)="hoverTooltipId = null; viewTooltip.hide()"
              (click)="isViewMode = true; viewDocument(data); $event.stopPropagation(); viewTooltip.hide()">
              <img src="assets/images/neveda-images/eye.svg" alt="" width="20" height="20" aria-hidden="true" />
            </button>
            <div
              *ngIf="hoverTooltipId === 'doc_view_' + data.document_id + '_' + rowIndex"
              class="tooltip-arrow-container"
              aria-hidden="true">
              <div class="tooltip-arrow-triangle"></div>
            </div>
          </span>

          <div class="download-wrapper">
            <span class="action-span-wrapper download-span">
              <button
                type="button"
                class="action-icon-button"
                [id]="'my_documents_button_download_' + data.document_id + '_' + rowIndex"
                #downloadTooltip="matTooltip"
                matTooltip="Download"
                matTooltipPosition="above"
                matTooltipTouchGestures="auto"
                [attr.aria-label]="'Download document ' + data.document_id"
                (mouseenter)="
                  hoverTooltipId = 'doc_download_' + data.document_id + '_' + rowIndex; downloadTooltip.show()
                "
                (mouseleave)="hoverTooltipId = null; downloadTooltip.hide()"
                (mouseleave)="hoverTooltipId = null; downloadTooltip.hide()"
                (click)="downloadDocument(data); $event.stopPropagation(); downloadTooltip.hide()">
                <img src="assets/images/neveda-images/download.svg" alt="" width="20" height="20" aria-hidden="true" />
              </button>
              <div
                *ngIf="hoverTooltipId === 'doc_download_' + data.document_id + '_' + rowIndex"
                class="tooltip-arrow-container"
                aria-hidden="true">
                <div class="tooltip-arrow-triangle"></div>
              </div>
            </span>
          </div>
        </div>
      </ng-template>
    </app-data-grid>
  </app-accordian>

  <!-- Transaction History Section -->
  <app-accordian [title]="transactionHistorySection.title">
    <div
      class="header-row p-2 d-flex align-items-center justify-content-end mb-0"
      id="transaction_history_div_headeractions">
      <app-grid-actions
        id="transaction_history_grid_actions"
        [actions]="transactionHistorySection.gridActions"
        [showColumnChooser]="transactionHistorySection.showColumnChooser"
        [allColumns]="transactionHistorySection.allColumns"
        [visibleColumns]="transactionHistorySection.visibleColumns"
        (exportClick)="onTransactionHistoryExport()"
        (columnChooserToggle)="onTransactionHistoryColumnChooserToggle()"
        (columnToggle)="onTransactionHistoryColumnToggle($event)"
        (columnChooserClose)="onTransactionHistoryColumnChooserClose()">
      </app-grid-actions>
    </div>
    <app-data-grid
      #transactionHistoryGrid
      [statusDataField]="'transactionStatus'"
      [submittedStatusValues]="['Paid']"
      [config]="transactionHistorySection.dataGridConfig"
      (assign)="onAssign($event.record, $event.assign, $event.selectedStaffMemberId, $event.personsByRole)"
      id="transaction_history_grid_datagrid"
      [onApplicationClick]="onApplicationIdClick">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div
          class="action-buttons-container"
          [attr.data-row]="rowIndex"
          role="group"
          [attr.aria-label]="'Actions for transaction ' + (data.id || data.paymentTransactionId)">
          <span class="action-span-wrapper view-wrapper"  *ngIf="data.transactionStatus?.toLowerCase() !== 'denied'">
            <button
              type="button"
              class="action-icon-button"
              [id]="'transaction_history_button_view_' + (data.id || data.paymentTransactionId) + '_' + rowIndex"
              #viewTooltip="matTooltip"
              matTooltip="View Receipt"
              matTooltipPosition="above"
              matTooltipTouchGestures="auto"
              [attr.aria-label]="'View transaction ' + (data.id || data.paymentTransactionId)"
              (mouseenter)="
                hoverTooltipId = 'transaction_view_' + (data.id || data.paymentTransactionId) + '_' + rowIndex;
                viewTooltip.show()
              "
              (mouseleave)="hoverTooltipId = null; viewTooltip.hide()"
             (click)="viewTransactionReceipt(data); $event.stopPropagation(); viewTooltip.hide()">
              <img src="assets/images/neveda-images/eye.svg" alt="" width="20" height="20" aria-hidden="true" />
            </button>
            <div
              *ngIf="hoverTooltipId === 'transaction_view_' + (data.id || data.paymentTransactionId) + '_' + rowIndex"
              class="tooltip-arrow-container"
              aria-hidden="true">
              <div class="tooltip-arrow-triangle"></div>
            </div>
          </span>

          <div class="download-wrapper">
            <span class="action-span-wrapper download-span"  *ngIf="data.transactionStatus?.toLowerCase() !== 'denied'">
              <button
                type="button"
                class="action-icon-button"
                [id]="'transaction_history_button_download_' + (data.id || data.paymentTransactionId) + '_' + rowIndex"
                #downloadTooltip="matTooltip"
                matTooltip="Download Receipt"
                matTooltipPosition="above"
                matTooltipTouchGestures="auto"
                [attr.aria-label]="'Download transaction receipt for ' + (data.id || data.paymentTransactionId)"
                (mouseenter)="
                  hoverTooltipId = 'transaction_download_' + (data.id || data.paymentTransactionId) + '_' + rowIndex;
                  downloadTooltip.show()
                "
                (mouseleave)="hoverTooltipId = null; downloadTooltip.hide()"
                (click)="downloadTransactionReceipt(data); $event.stopPropagation(); downloadTooltip.hide()">
                <img src="assets/images/neveda-images/download.svg" alt="" width="20" height="20" aria-hidden="true" />
              </button>
              <div
                *ngIf="
                  hoverTooltipId === 'transaction_download_' + (data.id || data.paymentTransactionId) + '_' + rowIndex
                "
                class="tooltip-arrow-container"
                aria-hidden="true">
                <div class="tooltip-arrow-triangle"></div>
              </div>
            </span>
          </div>
        </div>
      </ng-template>
    </app-data-grid>
  </app-accordian>

  <!-- Payment Breakdown Section -->
  <app-accordian [title]="paymentBreakdownSection.title">
    <div
      class="header-row p-2 d-flex align-items-center justify-content-end mb-0"
      id="payment_breakdown_div_headeractions">
      <app-grid-actions
        id="payment_breakdown_grid_actions"
        [actions]="paymentBreakdownSection.gridActions"
        [showColumnChooser]="paymentBreakdownSection.showColumnChooser"
        [allColumns]="paymentBreakdownSection.allColumns"
        [visibleColumns]="paymentBreakdownSection.visibleColumns"
        (exportClick)="onPaymentBreakdownExport()"
        (columnChooserToggle)="onPaymentBreakdownColumnChooserToggle()"
        (columnToggle)="onPaymentBreakdownColumnToggle($event)"
        (columnChooserClose)="onPaymentBreakdownColumnChooserClose()">
      </app-grid-actions>
    </div>
    <app-data-grid
      #paymentBreakdownGrid
      [config]="paymentBreakdownSection.dataGridConfig"
      [wordWrapEnabled]="false"
      id="payment_breakdown_grid_datagrid"
      [onApplicationClick]="onApplicationIdClick">
    </app-data-grid>
  </app-accordian>
</div>

<div *ngIf="showDeleteModal" class="delete-modal" id="dashboard_delete_modal">
  <div class="modal-content">
    <h2>Delete Application</h2>
    <p class="para-content">Are you sure you want to delete this application?</p>
    <p class="para-content">This action cannot be undone.</p>
    <hr />
    <div class="modal-actions">
      <button class="btn btn-secondary cancel-btn" (click)="closeDeleteModal()">Cancel</button>
      <button class="btn btn-danger delete-btn" (click)="deleteApplication(data)">Delete</button>
    </div>
  </div>
</div>

<ng-template #pdfPreviewModal let-modal>
  <div class="modal-header" style="background-color: #ffffff;">
    <h4 class="modal-title" style="color: #000000;">License Preview</h4>
    <button type="button" class="close" aria-label="Close" (click)="closePdfPreview()" style="color: #000000; opacity: 1;">
     <span aria-hidden="true" style="color: #000000;">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: 80vh">
    <iframe *ngIf="sanitizedPdfUrl" [src]="sanitizedPdfUrl" width="100%" height="100%"></iframe>
    <div *ngIf="!sanitizedPdfUrl">No PDF to display.</div>
  </div>
</ng-template>

<!-- </div> -->
